import 'core-js/stable';
import 'core-js/actual/array/group';
import 'regenerator-runtime/runtime';
import './i18n.js';
import '../common/axios/index';

import App from './app';

import register from 'utils/serviceworker/register';

// Initiate tracking
import 'utils/trackNudge';

// Page impression
import 'utils/trackPageImpression';
register();

new App();
